import React, { useMemo } from 'react';
import { Box, Inscription, WarningCard, WarningIcon } from '@common-fe/common-fe';

interface Props {
  firstName?: string;
  lastName?: string;
};

const EmailVerificationWarningMessage: React.FC<Props> = ({ firstName, lastName }) => {
  const fullName = useMemo(() => `${firstName} ${lastName}`, [firstName, lastName]);

  return (
    <WarningCard
      testId="email-verification-warning-message"
      borderColor="warningBorder"
      icon={<WarningIcon />}
      title={<Inscription weight={700}>Email verification required</Inscription>}
      width="100%"
      topBorderColor="transparent"
      border={{ size: '0px', color: 'transparent' }}
      containerProps={{
        pad: { vertical: 'spacing16', horizontal: 'spacing24' },
        round: 'container2Round'
      }}
    >
      <Box margin={{ top: 'spacing8' }}>
        <Inscription data-testId="email-verification-warning-message_subtitle">
          A verification link will be sent to {fullName}'s updated email address. The email must be verified to receive future communications.
        </Inscription>
      </Box>
    </WarningCard>
  );
};

export default EmailVerificationWarningMessage;
